// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import Description from '../../ui-helper-elements/Description'
import HoverMRRDescription from './HoverMRRDescription'
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports
// Bootstrap Imports
import Tooltip from 'react-bootstrap/Tooltip'

export default function MonthlyTotalRow() {
   const state = useQuoteContext()
   const { getString } = state
   const permissionsShowMRROnDifferenceQuotes =
      state.featurePermissions['ShowMRROnDifferenceQuotes']
   const ShowMRROnDifferenceQuotes =
      permissionsShowMRROnDifferenceQuotes.includes(state.user_role)

   const renderTooltip = (props) => (
      <Tooltip id='button-tooltip' {...props}>
         <div
            dangerouslySetInnerHTML={{
               __html: getString('product.MonthlyTotalRow.Tooltip'),
            }}
         />
      </Tooltip>
   )

   if (
      state.user_view == 'Internal' ||
      state.productPayrollTotalEECount > 0 ||
      state.hasUSEmployees == true
   )
      return (
         <div className='row grey-bold'>
            <div className='col-bhr1'>
               <b>{getString('global.MonthlyTotal')}</b>
            </div>
            <div className='col-bhr2'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               <b>
                  {formatFloatAsCurrencySymbol(
                     state.monthlyTotal.totalPrice,
                     state.currencyObject,
                  )}
               </b>
            </div>
            {state.differenceQuote == true ? (
               <>
                  <Description
                     className='col col-bhr-blue'
                     title={getString(
                        'product.MonthlyTotalRow.DiffHover.Title',
                     )}
                     content={
                        <div
                           dangerouslySetInnerHTML={{
                              __html: getString(
                                 'product.MonthlyTotalRow.DiffHover.Content',
                              ),
                           }}
                        />
                     }
                  >
                     <b>
                        <span className='hoverable'>
                           {state.accountSnowflake.Expected_Total_MRR__c !=
                              state.monthlyTotal.previousTotalPrice &&
                           'Expected_Total_MRR__c' in state.accountSnowflake ? (
                              <i>
                                 {formatFloatAsCurrencySymbol(
                                    state.monthlyTotal.previousTotalPrice,
                                    state.currencyObject,
                                 )}
                              </i>
                           ) : (
                              <b>
                                 {formatFloatAsCurrencySymbol(
                                    state.monthlyTotal.previousTotalPrice,
                                    state.currencyObject,
                                 )}
                              </b>
                           )}
                        </span>
                     </b>
                  </Description>
                  {ShowMRROnDifferenceQuotes ? (
                     <HoverMRRDescription
                        listMRRTotal={state.monthlyTotal.listMRRTotal}
                        previousMRRTotal={state.monthlyTotal.previousMRRTotal}
                        MRRTotal={state.monthlyTotal.MRRTotal}
                        MRRTotalUSD={state.monthlyTotal.MRRTotalUSD}
                        currencyObjectCurrent={state.currencyObject}
                        currencyObjectUSD={state.currencyObjectUSD}
                     >
                        <span className='hoverable'>
                           <b>
                              {formatFloatAsCurrencySymbol(
                                 state.monthlyTotal.totalPriceDifference,
                                 state.currencyObject,
                                 true,
                              )}
                           </b>
                        </span>
                     </HoverMRRDescription>
                  ) : (
                     <span className='col'>
                        <b>
                           {formatFloatAsCurrencySymbol(
                              state.monthlyTotal.totalPriceDifference,
                              state.currencyObject,
                              true,
                           )}
                        </b>
                     </span>
                  )}
                  {process.env.REACT_APP_ENVIRONMENT == 'staging' && (
                     <div className='col'>
                        <b>
                           {formatFloatAsCurrencySymbol(
                              state.monthlyTotal.MRRTotal,
                              state.currencyObject,
                           )}
                        </b>
                     </div>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
